<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <div class="nav-title-wrap">
          <span class="nav-devname">{{ udname }}</span>
          <span class="nav-did">补水日志</span>
        </div>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <div class="log-card">
        <div class="log-table-header">
          <span class="log-col log-col--trig">触发</span>
          <span class="log-col log-col--result">结果</span>
          <span class="log-col log-col--dur">时长(秒)</span>
          <span class="log-col log-col--time">结束时间</span>
        </div>

        <div v-for="item in historylist" :key="item" class="log-row">
          <span class="log-col log-col--trig">
            <span v-if="item.s === 1">自动</span>
            <span v-else-if="item.s === 2">手动</span>
            <span v-else-if="item.s === 3">预约</span>
          </span>
          <span class="log-col log-col--result">
            <span
              class="log-tag"
              :class="item.e === 0 ? 'log-tag--success' : 'log-tag--danger'"
            >
              <template v-if="item.e === 0">正常</template>
              <template v-else-if="item.e === -1">补水超时</template>
              <template v-else-if="item.e === -2">水泵无水</template>
              <template v-else-if="item.e === -3">暂停补水</template>
              <template v-else-if="item.e === -4">设置参数</template>
              <template v-else-if="item.e === -5">高水位异常</template>
              <template v-else-if="item.e === -6">手动结束</template>
            </span>
          </span>
          <span class="log-col log-col--dur">{{ item.t }}</span>
          <span class="log-col log-col--time">{{ item.time }}</span>
        </div>

        <div v-if="historylist.length === 0" class="log-empty">暂无日志记录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KD1Config",
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      udname: this.$route.query.udname,
      historylist: []
    };
  },
  mounted() {
    this.gethistory(7, "day");
  },
  methods: {
    gethistory(tnum, tunit) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({
          did: this.did,
          dtype: "KD-1",
          history: "log",
          tnum: tnum,
          tunit: tunit,
        }))
        .then((response) => {
          this.overlay = false;
          if (response.data.error_code === 0) {
            this.historylist = response.data.data.log_buf;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.content-area {
  padding: 12px;
}

.log-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.log-table-header {
  display: flex;
  align-items: center;
  background: #f8fafc;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.log-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.log-row:last-child {
  border-bottom: none;
}

.log-row:active {
  background: #f8fafc;
}

.log-col {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.log-col--trig {
  width: 15%;
  flex-shrink: 0;
}

.log-col--result {
  width: 25%;
  flex-shrink: 0;
}

.log-col--dur {
  width: 20%;
  flex-shrink: 0;
}

.log-col--time {
  flex: 1;
  text-align: right;
  color: #94a3b8;
  font-weight: 400;
  font-size: 12px;
}

.log-table-header .log-col {
  font-weight: 600;
  color: #64748b;
  font-size: 12px;
}

.log-table-header .log-col--time {
  color: #64748b;
  font-weight: 600;
}

.log-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
}

.log-tag--success {
  background: rgba(45, 212, 191, 0.12);
  color: #0d9488;
}

.log-tag--danger {
  background: rgba(251, 113, 133, 0.12);
  color: #e11d48;
}

.log-empty {
  text-align: center;
  padding: 40px 20px;
  font-size: 14px;
  color: #94a3b8;
}
</style>
